module.exports = __webpack_public_path__ + "img/mesa_l001l.816b81b2.png";